import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const API_BASE = "https://globizsystems.click";

function getToken() {
  return localStorage.getItem("token") || localStorage.getItem("agent_token") || "";
}

const SearchByUnit = () => {
  const navigate = useNavigate();

  const [msg, setMsg] = useState("");

  const [kawasans, setKawasans] = useState([]);
  const [units, setUnits] = useState([]);

  const [selectedKawasan, setSelectedKawasan] = useState("");
  const [selectedUnit, setSelectedUnit] = useState("");
  const [selectedNoAkaun, setSelectedNoAkaun] = useState("");

  const [loadingKawasans, setLoadingKawasans] = useState(false);
  const [loadingUnits, setLoadingUnits] = useState(false);

  const api = useMemo(() => {
    const token = getToken();
    return axios.create({
      baseURL: API_BASE,
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
  }, []);

  // 1) load only my assigned kawasans
  useEffect(() => {
    (async () => {
      try {
        setLoadingKawasans(true);
        setMsg("");
        const res = await api.get("/api/agent/kawasans/my");
        const arr = res.data || [];
        setKawasans(Array.isArray(arr) ? arr : []);
      } catch (e) {
        console.error(e);
        setMsg("Gagal muatkan senarai kawasan.");
      } finally {
        setLoadingKawasans(false);
      }
    })();
  }, [api]);

  // 2) load only my assigned units for selected kawasan
  useEffect(() => {
    if (!selectedKawasan) {
      setUnits([]);
      setSelectedUnit("");
      setSelectedNoAkaun("");
      return;
    }

    (async () => {
      try {
        setLoadingUnits(true);
        setMsg("");
        const res = await api.get("/api/agent/units", {
          params: { kawasan: selectedKawasan },
        });
        const arr = res.data || [];

        const filtered = Array.isArray(arr)
          ? arr.filter(
              (u) =>
                String(u.kawasan || "").trim() === String(selectedKawasan || "").trim()
            )
          : [];

        setUnits(filtered);
      } catch (e) {
        console.error(e);
        setMsg("Gagal muatkan senarai unit untuk kawasan ini.");
      } finally {
        setLoadingUnits(false);
      }
    })();
  }, [api, selectedKawasan]);

  const onSubmit = (e) => {
    e.preventDefault();

    if (!selectedNoAkaun) {
      setMsg("Sila pilih kawasan dan nombor unit.");
      return;
    }

    setMsg("");

    // renter-detail / lookup should now use no_akaun
    navigate("/renter-detail", {
      state: { qrResult: selectedNoAkaun },
    });
  };

  return (
    <div className="text-start">
      <h3 className="mb-2 font-semibold text-lg">Carian Mengikut Kawasan</h3>

      <form onSubmit={onSubmit}>
        <label className="block text-sm text-gray-600 mb-2">Kawasan</label>
        <select
          className="border-2 rounded-lg w-full py-2 px-3 bg-white"
          value={selectedKawasan}
          onChange={(e) => setSelectedKawasan(e.target.value)}
          disabled={loadingKawasans}
        >
          <option value="">
            {loadingKawasans ? "Memuatkan..." : "Pilih Kawasan"}
          </option>

          {kawasans.map((k, idx) => {
            const name = k.kawasan || k.kawasan_name || k.name || "";
            return (
              <option key={`${name}-${idx}`} value={name}>
                {name}
              </option>
            );
          })}
        </select>

        <label className="block text-sm text-gray-600 mt-4 mb-2">
          Nombor Unit
        </label>
        <select
          className="border-2 rounded-lg w-full py-2 px-3 bg-white"
          value={selectedUnit}
          onChange={(e) => {
            const unitNo = e.target.value;
            setSelectedUnit(unitNo);

            const row = units.find((u) => {
              const uNo = u.nombor_unit || u.nomborUnit || "";
              return String(uNo || "") === String(unitNo || "");
            });

            setSelectedNoAkaun(row?.no_akaun ? String(row.no_akaun) : "");
          }}
          disabled={!selectedKawasan || loadingUnits}
        >
          <option value="">
            {!selectedKawasan
              ? "Pilih kawasan dahulu"
              : loadingUnits
              ? "Memuatkan..."
              : "Pilih Nombor Unit"}
          </option>

          {units.map((u, idx) => {
            const unitNo = u.nombor_unit || u.nomborUnit || "";
            const noAkaun = u.no_akaun || "";
            return (
              <option key={`${unitNo}-${noAkaun}-${idx}`} value={unitNo}>
                {unitNo}
              </option>
            );
          })}
        </select>

        <button
          type="submit"
          className="mt-3 py-2 px-3 rounded-lg text-white bg-blue-500 font-semibold w-full hover:bg-blue-600 disabled:opacity-50"
          disabled={!selectedNoAkaun}
        >
          Cari
        </button>
      </form>

      {msg && <p className="text-sm text-red-600 mt-3">{msg}</p>}

      <p className="text-xs text-gray-500 mt-3">
        Tip: Jika QR anda mengandungi URL, gunakan fungsi Imbas QR.
      </p>
    </div>
  );
};

export default SearchByUnit;